import type { FC } from 'react';
import { useState } from 'react';
import { message, Modal } from 'antd';
import { deleteDocument } from '@/services/api/documentService';
import { deleteFolder } from '@/services/api/folderService';
import { useTranslation } from 'react-i18next';

interface DeleteModalProps {
  node: any;
  onLoadData: any;
  open: boolean;
  setCurrentNode: any;
  onCancel: () => void;
}

const ModalDeleteFile: FC<DeleteModalProps> = ({
  node,
  onLoadData,
  open,
  setCurrentNode,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<any>(false);

  const handleOk = async () => {
    let response;
    setIsLoading(true);
    if (node.isLeaf) {
      response = await deleteDocument({ document_id: node.key });
    } else {
      response = await deleteFolder({ folder_id: node.key });
    }
    if (!response.success) {
      setIsLoading(false);
      return;
    }
    onLoadData(node);
    setIsLoading(false);
    onCancel();
  };
  return (
    <Modal
      title={t('home.documents.modals.delete.title')}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      cancelText={t('home.documents.modals.delete.cancel')}
      okText={t('home.documents.modals.delete.confirm')}
      okType="danger"
      okButtonProps={{
        style: {
          color: 'white',
          backgroundColor: '#FF4D4F',
          borderColor: '#FF4D4F',
        },
      }}
      confirmLoading={isLoading}
    >
      <b>
        {t('home.documents.modals.delete.content', { fileName: node?.name })}
      </b>
    </Modal>
  );
};

export default ModalDeleteFile;
